import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';
import './VerifyCertPage.css';

export default function VerifyCertPage() {
  const { id } = useParams();
  const [cert, setCert] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/certificates/verify/${id}`)
      .then(r => setCert(r.data))
      .catch(err => setError('الشهادة غير موجودة أو الكود غير صحيح'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="verify-page-loading"><div className="spinner" /></div>;

  return (
    <div className="verify-page">
      <div className="verify-card card">
        <div className="verify-logo">مدرسك</div>

        {error ? (
          <div className="verify-error">
            <div className="verify-icon">❌</div>
            <h2>تعذر التحقق من الشهادة</h2>
            <p>{error}</p>
            <Link to="/" className="btn btn-primary">العودة للرئيسية</Link>
          </div>
        ) : (
          <div className="verify-success">
            <div className="verify-icon">✅</div>
            <h1 className="verify-title">شهادة موثقة</h1>
            <p className="verify-sub">تم التحقق من صحة هذه الشهادة من قاعدة بيانات مدرسك</p>

            <div className="verify-details">
              <div className="v-row"><span>اسم الطالب:</span><strong>{cert.studentName}</strong></div>
              <div className="v-row">
                <span>اسم الكورس:</span>
                <Link to={`/courses/${cert.courseSlug || cert.courseId}`} style={{ fontWeight: 700, color: 'var(--blue)' }}>
                  {cert.courseTitle}
                </Link>
              </div>
              <div className="v-row">
                <span>اسم المدرس:</span>
                <Link to={`/teachers/${cert.teacherUsername || cert.teacherId}`} style={{ fontWeight: 700, color: 'var(--blue)' }}>
                  {cert.teacherName}
                </Link>
              </div>
              <div className="v-row"><span>تاريخ الإصدار:</span><strong>{new Date(cert.completedAt).toLocaleDateString('ar-EG')}</strong></div>
              <div className="v-row"><span>كود الشهادة:</span><code style={{fontSize: 12}}>{cert.id}</code></div>
              {cert.score && <div className="v-row"><span>التقدير:</span><strong>{cert.score}%</strong></div>}
            </div>

            <div className="verify-badge">
                {cert.isPremium ? '💎 شهادة بريميوم موثقة' : '✔️ شهادة إتمام موثقة'}
            </div>

            <div style={{ marginTop: 30 }}>
                <Link to="/courses" className="btn btn-outline">تصفح الكورسات التعليمية</Link>
            </div>
          </div>
        )}
      </div>

      <div className="verify-footer">
        © {new Date().getFullYear()} منصة مدرسك التعليمية — جميع الحقوق محفوظة
      </div>
    </div>
  );
}
